import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import UI from '../../common/UI';

interface PageLoaderProps {
  throttled?: boolean;
  height?: number | string;
}

const PageLoader = ({ throttled, height }: PageLoaderProps) => {
  const { t } = useTranslation();

  const [showMessage, setShowMessage] = useState(throttled);
  const message = throttled ? t('common:validation.too_many_attempts') : t('slow_fetch_message');

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowMessage(true);
    }, 3000);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <UI.FlexContainer
      sc={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center', direction: 'column' }}
      style={{ height }}
    >
      <UI.PageLoader height="auto" />
      {showMessage && (
        <UI.Div sc={{ mt: 4 }}>
          {message}
        </UI.Div>
      )}
    </UI.FlexContainer>
  );
};

export default PageLoader;
